<template>
    <sub-page :fullPage="true" class="m-ledgerDetail">
        <div v-if="data" class="ledger-detail">
            <h2 class="ledger-title">{{data.name}}</h2>
            <div class="ledger-items">
                <p>培训类别：{{data.typeName}}</p>
                <p>培训名称：{{data.name}}</p>
                <p>项目类别：{{data.projectTypeName}}</p>

                <p>考核方式：{{data.formName}}</p>
                <p>学时：{{data.hours}}</p>
                <p>学分：{{data.score}}</p>

                <p>培训地点：{{data.place}}</p>
                <p>培训人数：{{data.numOfTrainees}}</p>
                <p>年度：{{data.year}}</p>

                <p>实施时间：{{data.startTime && data.startTime.slice(0,10)}}</p>
                <p>结束时间：{{data.endTime && data.endTime.slice(0,10)}}</p>
                <p>考核日期：{{data.assessmentTime && data.assessmentTime.slice(0,10)}}</p>

                <p>授课人员：{{data.trainer}}</p>
                <p>内训师级别：{{data.trainerLevelName}}</p>
                <p>培训部门：{{data.institutions}}</p>

                <p>台账来源：{{data.originName}}</p>

            </div>
            <div class="ledger-members">
                <h3>培训人员：</h3>
                <div class="members">
                    <el-tag size="small" v-for="item in data.participants" :key="item.userId" :title.native="item.name">{{item.userName}}</el-tag>
                </div>
            </div>
            <div v-if="data.content" class="ledger-content">
                <h3>培训内容：</h3>
                <p>{{data.content}}</p>
            </div>
            <div v-if="initFiles.length" class="ledger-attachment">
                <h3>附件 (<span style="color:#22B9FF"> {{initFiles.length}} </span>)：</h3>
                <ledger-file :initFiles="initFiles" :readonly="true"></ledger-file>
            </div>
            <div v-if="data.remark" class="ledger-content" style="margin-top: 10px;">
                <h3>备注：</h3>
                <p>{{data.remark}}</p>
            </div>
        </div>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage.vue'
    import ledgerFile from './Components/File'

    export default {
        props: ['ledgerId'],
        components: {
            SubPage, ledgerFile
        },
        data() {
            return {
                data: null,
                initFiles: []
            }
        },
        created() {
            this.initData()
        },
        mounted() {
            // fix: 页面定位问题
            if (this.$route.name === 'studentLedgerDetail') {
                setTimeout(() => {
                    $('.m-ledgerDetail').css({
                        top: 0
                    });
                }, 100)
            }
        },
        methods: {
            initData() {
                api.getStandingBook(this.ledgerId).then(res => {
                    this.data = res.package;
                    let orgArr = res.package.institutions.map(item => item.orgName);
                    this.data.institutions = orgArr.join();
                    this.initFiles = this.data.attachments;
                })
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .ledger-detail {
        width: 960px;
        margin: 0 auto;

        .ledger-title {
            margin-bottom: 20px;
            text-align: center;
            font-size: 20px;
        }

        .ledger-items {
            display: flex;
            flex-wrap: wrap;
            padding-bottom: 5px;
            line-height: 1.6;
            //border-bottom: 1px solid #dcdfe6;
            > p {
                flex-basis: 33%;
                margin-bottom: 10px;
            }
        }

        .ledger-block {
            display: flex;
            margin-top: 20px;
            > h3 {
                width: 80px;
                text-align: right;
                margin-right: 5px;
            }
            > p {
                flex: 1;
            }
        }

        .ledger-members {
            @extend .ledger-block;
            margin-top: 5px;
            display: flex;
            .members {
                padding: 10px 10px 0 10px;
                flex: 1;
                max-height: 300px;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                overflow-y: auto;
                .el-tag {
                    margin-right: 8px;
                    width: 10%;
                    margin-bottom: 8px;
                    @include no-wrap
                }
            }
        }

        .ledger-content {
            @extend .ledger-block;
            line-height: 1.8;
        }

        .ledger-attachment {
            @extend .ledger-block;

            .ledger-file {
                flex: 1;
            }
            /deep/.el-upload-list__item {
                width: 135px;
                height: 135px;
                margin-right: 10px;
                margin-bottom: 10px;
            }
        }
    }
</style>
